// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"83":"flatpickrLocale","694":"flatpickr","754":"@glidejs/glide"}[chunkId] || chunkId) + ".chunk.js";
};